import React from 'react'

const StartForm = React.lazy(() => import('containers/StartForm/StartForm'))
const LoginPage = React.lazy(() => import('./containers/Login/LoginPage'))
const Register = React.lazy(() => import('./containers/Register/Register'))
const EmailRequest = React.lazy(() => import('./containers/Login/EmailRequest'))
const setPassword = React.lazy(() => import('./containers/Login/setPassword'))
const Dashboard = React.lazy(() => import('./containers/Dashboard/Dashboard'))
const App = React.lazy(() => import('./containers/Apps/App/App'))
const AllAppSelected = React.lazy(() => import('./containers/Apps/AllApps/AllAppSelected'))
const ConfigureWorkflow = React.lazy(() => import('./containers/Apps/ConfigureApp/ConfigWorkflow'))
const Users = React.lazy(() => import('containers/Config/Users/UsersList/UsersList'))
const UsersWorkerView = React.lazy(() => import('containers/Config/Users/UsersList/UsersWorkerViewList'))
const UserCreate = React.lazy(() => import('./containers/Config/Users/User'))
const UserEdit = React.lazy(() => import('./containers/Config/Users/User'))
const LocationList = React.lazy(() => import('./containers/Config/Location/LocationList/LocationList'))
const LocationCreateEdit = React.lazy(() => import('./containers/Config/Location/LocationCreateEdit'))
const Formbuilder = React.lazy(() => import('./containers/FormBuilder/FormbuilderCreate'))
const FormBuilderEdit = React.lazy(() => import('./containers/FormBuilder/FormBuilderEdit'))
const FormBuilderPreview = React.lazy(() => import('./containers/FormBuilder/FormBuilderPreview'))
const GroupList = React.lazy(() => import('./containers/Config/Groups/GroupList/GroupList'))
const GroupCreateEdit = React.lazy(() => import('./containers/Config/Groups/GroupCreateEdit'))
const DepartmentList = React.lazy(() => import('./containers/Config/Department/DepartmentList/DepartmentList'))
const DepartmentCreateEdit = React.lazy(() => import('./containers/Config/Department/DepartmentCreateEdit'))
const Process = React.lazy(() => import('./containers/Process/Process'))
const ProcessOkayGo = React.lazy(() => import('./containers/ProcessOkaygo/Process'))
const Tasks = React.lazy(() => import('./containers/Tasks'))
const TaskVerification = React.lazy(() => import('./containers/Tasks/taskAction'))
const SmtpCreate = React.lazy(() => import('./containers/Config/SMTP/Smtp'))
const Portals = React.lazy(() => import('./containers/Portals/portals'))
const Contents = React.lazy(() => import('./containers/Portals/content'))
const ContentCreateEdit = React.lazy(() => import('containers/Portals/ContentCreateEdit'))
const Theme = React.lazy(() => import('./containers/Config/theme/theme'))
const UserProfile = React.lazy(() => import('./containers/Dashboard/userProfile/userProfile'))
const ManageAccount = React.lazy(() => import('./containers/Dashboard/userProfile/ManageAccount'))
const ConfigView = React.lazy(() => import('./containers/Config/View/ConfigView'))
const Report = React.lazy(() => import('./containers/Report/ReportsList'))
const ReportCreateEdit = React.lazy(() => import('./containers/Report/ReportForm'))
const Master = React.lazy(() => import('./containers/Master'))
const CustomData = React.lazy(() => import('./containers/Config/CustomData'))
const CustomDataEdit = React.lazy(() => import('./containers/Config/CustomData/CustomDataEdit'))
const CustomDataCreate = React.lazy(() => import('./containers/Config/CustomData/CustomDataCreate'))
const ImportHistory = React.lazy(() => import('./components/UI/ImportHistory/ImportHistory'))
const EntityList = React.lazy(() => import('./containers/Entities/List/EntityList'))
const EntityView = React.lazy(() => import('./containers/Entities/View/EntityView'))
const AdvList = React.lazy(() => import('./containers/AdvList/ListView/AdvancedList'))
const AdvListDetail = React.lazy(() => import('./containers/AdvList/DetailView/Wrapper'))

const StockList = React.lazy(() => import('./containers/Inventory/Stock/StockList/StockList'))
const StockAdjust = React.lazy(() => import('./containers/Inventory/Stock/AdjustStock/AdjustStock'))
const StockThreshold = React.lazy(() => import('./containers/Inventory/Stock/ThresholdStock/ThresholdStock'))
const StockAdjustList = React.lazy(() => import('./containers/Inventory/StockAdjustment/StockAdjustList'))
const DistributionList = React.lazy(() => import('./containers/Inventory/Distribution/DistributionList/Distributions'))
const DistributionCreate = React.lazy(() => import('./containers/Inventory/Distribution/DistributionCreate/DistributionCreate'))
const DistributionTransferList = React.lazy(() => import('./containers/Inventory/Distribution/DistributionList/DistributionTransfers'))
const DistributionOthersList = React.lazy(() => import('./containers/Inventory/Distribution/DistributionList/DistributionOthers'))
const AssetList = React.lazy(() => import('./containers/Inventory/Asset/AssetList/AssetsList'))
const KitList = React.lazy(() => import('./containers/Inventory/Kit/KitsList/KitList'))
const KitCreateOrEdit = React.lazy(() => import('./containers/Inventory/Kit/KitCreateEdit/KitCreateEdit'))
const AssetCreateOrEdit = React.lazy(() => import('./containers/Inventory/Asset/AssetCreateOrEdit/AssetCreateOrEdit'))
const SupplierList = React.lazy(() => import('./containers/Inventory/Supplier/SupplierList/SuppliersList'))
const SupplierCreateOrEdit = React.lazy(() => import('./containers/Inventory/Supplier/SupplierCreateOrEdit/SupplierCreateOrEdit'))
const SupplyList = React.lazy(() => import('./containers/Inventory/Supply/SupplyList/Supplies'))
const SupplyCreateOrEdit = React.lazy(() => import('./containers/Inventory/Supply/SupplyCreateOrEdit/SupplyCreateOrEdit'))
const ScheduleReport = React.lazy(() => import('./containers/Report/SchedulerModal/Schedular'))
const CustomRole = React.lazy(() => import('./containers/Config/CustomRole/CustomRole'))
const CustomAttributes = React.lazy(() => import('./containers/Config/CustomAttributes/index'))
const DashboardCreateOrEdit = React.lazy(() => import('./containers/Config/View/DashboardConfig/DashboardCreateOrEdit'))
const BGV = React.lazy(() => import('./containers/Bgv'))
// const BGVDETAIL = React.lazy(() => import('containers/Bgv/BgvDetail'))
const EzeDigiLocker = React.lazy(() => import('./containers/DigiLocker/EzeDigiLocker'))

const Hiring = React.lazy(() => import('./containers/Hiring/Hiring'))
const JobList = React.lazy(() => import('./containers/Hiring/Jobs/JobList'))
const JobView = React.lazy(() => import('./containers/Hiring/Jobs/JobView'))
const HeadCount = React.lazy(() => import('./containers/Hiring/Headcount/HeadCount'))
const HeadCountPlan = React.lazy(() => import('./containers/Hiring/Headcount/HeadCountPlanning'))
const Requisition = React.lazy(() => import('./containers/Hiring/Headcount/Requisition'))
const HiringEventList = React.lazy(() => import('./containers/Hiring/HiringEvent/HiringEventList'))
const CreateEditHiringEvent = React.lazy(() => import('./containers/Hiring/HiringEvent/CreateEditHiringEvent'))
const HiringPartnerList = React.lazy(() => import('./containers/Hiring/HiringPartner/HiringPartnerList'))
const CreateEditHiringPartner = React.lazy(() => import('./containers/Hiring/HiringPartner/CreateEditHiringPartner'))
const JobRoleList = React.lazy(() => import('./containers/Hiring/JobRole/JobRoleList'))
const CreateEditJobRole = React.lazy(() => import('./containers/Hiring/JobRole/JobRoleCreateEdit'))
const JobPortalList = React.lazy(() => import('./containers/Hiring/JobPortal/JobPortal'))
const JobPortalView = React.lazy(() => import('./containers/Hiring/JobPortal/JobPortalView'))
const JobEventChartConfigCreateEdit = React.lazy(() => import('./containers/Config/View/JobEventChartConfig/JobEventChartConfigCreateEdit'))

const routes = {
    LOGIN: {
        to: () => `/login`,
        path: '/login',
        component: LoginPage
    },
    REGISTER: {
        to: () => `/register`,
        path: '/',
        component: Register
    },
    SET_PASSWORD: {
        to: (id, token) => `/users/org_users/reset_password/${id}/${token}`,
        path: '/users/org_users/reset_password/:id/:token',
        api: (uidb64, token) => `/api/users/org_users/reset_password/${uidb64}/${token}`,
        component: setPassword
    },
    EMAIL_REQUEST: {
        to: () => `/getpassword`,
        path: '/getpassword',
        component: EmailRequest
    },
    DIGILOCKER: {
        path: '/dl',
        component: EzeDigiLocker,
    },
    DASHBOARD: {
        to: () => `/dashboard`,
        path: '/dashboard',
        component: Dashboard
    },
    APP: {
        to: () => ``,
        path: '/workflows/add',
        component: App,
        api: () => `workflows/count`
    },
    APP_ADD: {
        to: () => `/workflows/add`,
        path: '/workflows',
        component: AllAppSelected,
    },
    APP_CONFIGURE: {
        to: () => `/workflows/add/configure`,
        path: '/workflows/add/:id',
        component: ConfigureWorkflow,
    },
    FORM_PREVIEW: {
        to: () => `/formbuilder/`,
        path: '/formbuilder/preview',
        component: FormBuilderPreview,
    },
    FORM_BUILDER: {
        to: () => `/formbuilder/`,
        path: '/formbuilder/create/:id',
        component: Formbuilder,
    },
    FORM_EDIT: {
        to: () => `/formbuilder/`,
        path: '/formbuilder/edit',
        component: FormBuilderEdit,
    },
    USERS: {
        to: () => `/users`,
        path: '/users',
        component: Users,
    },
    WORKER_VIEW: {
        to: () => `/worker_view`,
        path: '/worker_view',
        component: UsersWorkerView,
    },
    USER_CREATE: {
        to: page => `/users/create?next=${page}`,
        path: '/users/create',
        component: UserCreate,
    },
    USER_EDIT: {
        to: (id, page) => `/users/edit/${id}?next=${page}`,
        path: '/users/edit/:id',
        component: UserEdit
    },
    LOCATION_LIST: {
        to: () => `/location`,
        path: '/location',
        component: LocationList,
    },
    LOCATION_CREATE: {
        to: page => `/location/create?next=${page}`,
        path: '/location/create',
        component: LocationCreateEdit,
    },
    LOCATION_EDIT: {
        to: (id, page) => `/location/edit/${id}?next=${page}`,
        path: `/location/edit/:id`,
        component: LocationCreateEdit
    },
    GROUP_LIST: {
        to: () => `/groups`,
        path: '/groups',
        component: GroupList,
    },
    GROUP_CREATE: {
        to: page => `/groups/create?next=${page}`,
        path: '/groups/create',
        component: GroupCreateEdit,
    },
    GROUP_EDIT: {
        to: (id, page) => `/groups/edit/${id}?next=${page}`,
        path: `/groups/edit/:id`,
        component: GroupCreateEdit
    },
    DEPARTMENT_LIST: {
        to: () => `/department`,
        path: '/department',
        component: DepartmentList,
    },
    DEPARTMENT_CREATE: {
        to: page => `/department/create?next=${page}`,
        path: '/department/create',
        component: DepartmentCreateEdit,
    },
    DEPARTMENT_EDIT: {
        to: (id, page) => `/department/edit/${id}?next=${page}`,
        path: `/department/edit/:id`,
        component: DepartmentCreateEdit,
    },
    PROCESS: {
        to: () => `/process`,
        path: '/process',
        component: Process,
    },
    PROCESS_OKAYGO: {
        to: () => `/process_okaygo`,
        path: '/process_okaygo',
        component: ProcessOkayGo,
    },
    TASKS: {
        to: () => `/tasks`,
        path: '/tasks',
        component: Tasks,
    },
    TASK_DETAILS: {
        to: () => ``,
        path: '/tasks/:id',
        component: TaskVerification,
    },
    SMTP_CREATE: {
        to: () => '/smtp',
        path: '/smtp',
        component: SmtpCreate
    },
    PORTALS: {
        to: () => ``,
        path: '/portals',
        component: Portals,
    },
    CONTENTS: {
        to: () => ``,
        path: '/contents',
        component: Contents,
    },
    CONTENTS_ID: {
        to: () => ``,
        path: '/content/edit/:id',
        component: ContentCreateEdit,
    },
    THEMES: {
        to: () => `/themes`,
        path: '/themes',
        component: Theme,
    },
    PROFILE: {
        to: () => `/profile`,
        path: '/profile',
        component: UserProfile,
    },
    MANAGEACCOUNT: {
        to: () => `/manage-account`,
        path: '/manage-account',
        component: ManageAccount,
    },
    PORTAL_CREATE: {
        to: () => `/contents/create`,
        path: '/contents/create',
        component: ContentCreateEdit,
    },
    CONFIG_VIEW: {
        to: () => `/view`,
        path: `/view`,
        component: ConfigView,
    },
    REPORT: {
        to: () => `/reports`,
        path: `/reports`,
        component: Report,
    },
    REPORT_CREATE: {
        to: page => `/reports/create?next=${page}`,
        path: `/reports/create`,
        component: ReportCreateEdit
    },
    REPORT_EDIT: {
        to: (id,page) => `/reports/edit/${id}?next=${page}`,
        path: `/reports/edit/:id`,
        component: ReportCreateEdit
    },
    REPORT_SCHEDULE: {
        to: () => `/reports/scheduler`,
        path: `/reports/:id/scheduler`,
        component: ScheduleReport
    },
    STOCK_LIST: {
        to: page => `/inventory/stock?page=${page}`,
        path: '/inventory/stock',
        component: StockList,
    },
    STOCK_ADJUST: {
        to: (id, page) => `/inventory/stock/adjust/${id}?next=${page}`,
        path: '/inventory/stock/adjust/:id',
        component: StockAdjust,
    },
    STOCK_THRESHOLD: {
        to: (id, page) => `/inventory/stock/threshold/${id}?next=${page}`,
        path: '/inventory/stock/threshold/:id',
        component: StockThreshold,
    },
    STOCK_ADJUST_LIST: {
        to: (page = 1) => `/inventory/stock/adjustments?page=${page}`,
        path: '/inventory/stock/adjustments',
        component: StockAdjustList,
    },
    ASSET_LIST: {
        to: () => `/inventory/asset`,
        path: '/inventory/asset',
        component: AssetList,
    },
    ASSET_CREATE: {
        to: page => `/inventory/asset/create?next=${page}`,
        path: '/inventory/asset/create',
        component: AssetCreateOrEdit,
    },
    ASSET_EDIT: {
        to: (id, page) => `/inventory/asset/edit/${id}?next=${page}`,
        path: `/inventory/asset/edit/:id`,
        component: AssetCreateOrEdit,
    },
    KIT_LIST: {
        to: page => `/inventory/kit?page=${page}`,
        path: '/inventory/kit',
        component: KitList,
    },
    KIT_CREATE: {
        to: page => `/inventory/kit/create?next=${page}`,
        path: '/inventory/kit/create',
        component: KitCreateOrEdit,
    },
    KIT_EDIT: {
        to: (id, page) => `/inventory/kit/edit/${id}?next=${page}`,
        path: '/inventory/kit/edit/:id',
        component: KitCreateOrEdit,
    },
    DISTRIBUTION_LIST: {
        to: page => `/inventory/distribution?page=${page}`,
        path: '/inventory/distribution',
        component: DistributionList,
    },
    DISTRIBUTION_CREATE: {
        to: page => `/inventory/distribution/create?next=${page}`,
        path: '/inventory/distribution/create',
        component: DistributionCreate,
    },
    DISTRIBUTION_INTER_TRANSFER_LIST: {
        to: page => `/inventory/distribution/inter?page=${page}`,
        path: '/inventory/distribution/inter',
        component: DistributionTransferList,
    },
    DISTRIBUTION_OTHER_TRANSFER_LIST: {
        to: page => `/inventory/distribution/others?page=${page}`,
        path: '/inventory/distribution/others',
        component: DistributionOthersList,
    },
    DISTRIBUTION_INTER_TRANSFER_CREATE: {
        to: page => `/inventory/distribution/inter/create?next=${page}`,
        path: '/inventory/distribution/inter/create',
        component: DistributionCreate,
    },
    SUPPLIER_LIST: {
        to: () => `/inventory/supplier`,
        path: '/inventory/supplier',
        component: SupplierList,
    },
    SUPPLIER_CREATE: {
        to: page => `/inventory/supplier/create?next=${page}`,
        path: '/inventory/supplier/create',
        component: SupplierCreateOrEdit,
    },
    SUPPLIER_EDIT: {
        to: (id, page) => `/inventory/supplier/edit/${id}?next=${page}`,
        path: '/inventory/supplier/edit/:id',
        component: SupplierCreateOrEdit,
    },
    SUPPLY_LIST: {
        to: page => `/inventory/supply?page=${page}`,
        path: '/inventory/supply',
        component: SupplyList,
    },
    SUPPLY_CREATE: {
        to: page => `/inventory/supply/create?next=${page}`,
        path: '/inventory/supply/create',
        component: SupplyCreateOrEdit,
    },
    SUPPLY_EDIT: {
        to: (id, page) => `/inventory/supply/edit/${id}?next=${page}`,
        path: '/inventory/supply/edit/:id',
        component: SupplyCreateOrEdit,
    },
    MASTER: {
        to: () => '/master',
        path: `/master`,
        component: Master
    },
    CUSTOM_DATA: {
        to: () => `/lists`,
        path: `/lists`,
        component: CustomData
    },
    CUSTOM_DATA_EDIT: {
        to: (id, page) => `/lists/edit/${id}?next=${page}`,
        path: `/lists/edit/:id`,
        component: CustomDataEdit
    },
    CUSTOM_DATA_CREATE: {
        to: page => `/lists/create?next=${page}`,
        path: `/lists/create`,
        component: CustomDataCreate
    },
    ADVANCED_LIST: {
        to: () => `/lists/advanced`,
        path: '/lists/advanced',
        component: AdvList,
    },
    ADVANCED_LIST_DETAIL: {
        to: (id) => `/lists/advanced/edit/${id}`,
        path: '/lists/advanced/edit/:id',
        component: AdvListDetail,
    },
    LOCATION_HISTORY: {
        to: () => `/location/import-history`,
        path: `/location/import-history`,
        component: ImportHistory,
        entity: 'location',
        breadCrumb: {
            list: [{
                name: 'Locations',
                path: '/location'
            }]
        }
    },
    USER_HISTORY: {
        to: () => `/users/import-history`,
        path: `/users/import-history`,
        component: ImportHistory,
        entity: 'user',
        breadCrumb: {
            list: [{
                name: 'Users',
                path: '/users'
            }]
        }
    },
    GROUP_HISTORY: {
        to: () => `/groups/import-history`,
        path: `/groups/import-history`,
        component: ImportHistory,
        entity: 'groups',
        breadCrumb: {
            list: [{
                name: 'Groups',
                path: '/groups'
            }]
        }
    },
    BULK_INITIATE_HISTORY: {
        to: () => '/process/import-history',
        path: '/process/import-history',
        component: ImportHistory,
        entity: 'bulk_initiate_process',
        breadCrumb: {
            list: [{
                name: 'Processes',
                path: '/process'
            }]
        }
    },
    ENTITY_LIST: {
        to: () => `/entity`,
        path: '/entity/:id',
        component: EntityList,
    },
    ENTITY_DETAILS: {
        to: (entityModelId, entityViewId, entityId) => `/entity/${entityModelId}/${entityViewId}/edit/${entityId}`,
        jobTo: (entityModelId, entityViewId, entityId, jobId, eventId, profileButton) => `/entity/${entityModelId}/${entityViewId}/edit/${entityId}?jobId=${jobId}&eventId=${eventId || ""}&profileButton=${profileButton}`,
        path: '/entity/:entityModelId/:entityViewId/edit/:entityId',
        component: EntityView,
    },
    CUSTOM_ROLE: {
        to: () => `/config/role`,
        path: `/config/role`,
        component: CustomRole
    },
    CUSTOM_ATTRIBUTES: {
        path: '/custom-attributes',
        component: CustomAttributes
    },
    CREATE_DASHBOARD: {
        to: page => `/view/dashboard/add?next=${page}`,
        path: `/view/dashboard/add`,
        component: DashboardCreateOrEdit
    },
    EDIT_DASHBOARD: {
        to: (id,page) => `/view/dashboard/edit/${id}?next=${page}`,
        path: `/view/dashboard/edit/:id`,
        component: DashboardCreateOrEdit
    },
    START_NEW_PROCESS: {
        to: processId => `/start-new-process/${processId}`,
        path: '/start-new-process/:processId',
        component: StartForm
    },
    BGV: {
        path: '/bgv',
        component: BGV
    },
    // BGVDETAIL: {
    //   path: '/bgv/:id',
    //   component: BGVDETAIL
    // },
    JOB_PORTAL_LIST: {
        to: (next = 1) => `/jobs?page=${next}`,
        path: '/jobs',
        component: JobPortalList
    },
    JOB_PORTAL_VIEW: {
        to: (id, page = 1) => `/jobs/${id}?next=${page}`,
        path: '/jobs/:id',
        component: JobPortalView
    },
    HIRING: {
        to: () => '/hiring',
        path: '/hiring',
        component: Hiring
    },
    JOB_LIST: {
        to: (next = 1) => `/job?page=${next}`,
        eventTo: (eventId, profileButton = 'show', page = 1) => `/job?eventId=${eventId}&profileButton=${profileButton}&next=${page}`,
        path: '/job',
        component: JobList
    },
    JOB_VIEW: {
        to: (id, page = 1) => `/job/${id}?next=${page}`,
        eventTo: (id, eventId, profileButton = 'show') => `/job/${id}?eventId=${eventId}&profileButton=${profileButton}`,
        path: '/job/:id',
        component: JobView
    },
    JOB_HISTORY: {
        to: () => '/job/import-history',
        path: '/job/import-history',
        api: '/api/apps/hiring/bulk_initiate?entity=bulk_initiate_job',
        component: ImportHistory,
        app_key: 'hiring',
        entity: 'bulk_initiate_job',
        breadCrumb: {
            list: [{
                name: 'Jobs',
                path: '/job'
            }]
        }
    },
    JOB_CANDIDATE_HISTORY: {
        to: () => '/job/candidate/import-history',
        path: '/job/candidate/import-history',
        api: '/api/apps/hire_candidate/bulk_initiate?entity=bulk_initiate_profile',
        component: ImportHistory,
        app_key: 'hire_candidate',
        entity: 'bulk_initiate_profile',
        breadCrumb: {
            list: [{
                name: 'Job Profiles',
                path: '/job'
            }]
        }
    },
    HEAD_COUNT: {
        to: (next = 1) => `/headcount?page=${next}`,
        path: '/headcount',
        component: HeadCount
    },
    HEAD_COUNT_PLAN: {
        to: (page = 1) => `/headcount/plan?next=${page}`,
        path: '/headcount/plan',
        component: HeadCountPlan
    },
    REQUISITION: {
        to: (page = 1) => `/headcount/requisition?next=${page}`,
        path: '/headcount/requisition',
        component: Requisition
    },
    HIRING_EVENT_LIST: {
        to: (next = 1) => `/event?page=${next}`,
        path: '/event',
        component: HiringEventList
    },
    HIRING_EVENT_CREATE: {
        to: (page = 1) => `/event/create?next=${page}`,
        path: '/event/create',
        component: CreateEditHiringEvent,
    },
    HIRING_EVENT_EDIT: {
        to: (id, page = 1) => `/event/edit/${id}?next=${page}`,
        path: '/event/edit/:id',
        component: CreateEditHiringEvent,
    },
    HIRING_PARTNER_LIST: {
        to: (next = 1) => `/partner?page=${next}`,
        path: '/partner',
        component: HiringPartnerList
    },
    HIRING_PARTNER_CREATE: {
        to: (page = 1) => `/partner/create?next=${page}`,
        path: '/partner/create',
        component: CreateEditHiringPartner,
    },
    HIRING_PARTNER_EDIT: {
        to: (id, page = 1) => `/partner/edit/${id}?next=${page}`,
        path: '/partner/edit/:id',
        component: CreateEditHiringPartner,
    },
    JOB_ROLE_LIST: {
        to: (next = 1) => `/jobrole?page=${next}`,
        path: '/jobrole',
        component: JobRoleList
    },
    JOB_ROLE_CREATE: {
        to: (page = 1) => `/jobrole/create?next=${page}`,
        path: '/jobrole/create',
        component: CreateEditJobRole,
    },
    JOB_ROLE_EDIT: {
        to: (id, page = 1) => `/jobrole/edit/${id}?next=${page}`,
        path: '/jobrole/edit/:id',
        component: CreateEditJobRole,
    },
    ADD_JOB_CHART_CONFIG: {
        to: (pageType, page) => `/view/job/add?next=${page}&pageType=${pageType}`,
        path: `/view/job/add`,
        component: JobEventChartConfigCreateEdit,
    },
    EDIT_JOB_CHART_CONFIG: {
        to: (pageType, id, page) => `/view/job/edit/${id}?next=${page}&pageType=${pageType}`,
        path: `/view/job/edit/:id`,
        component: JobEventChartConfigCreateEdit,
    },
    ADD_EVENT_CHART_CONFIG: {
        to: (pageType, page) => `/view/event/add?next=${page}&pageType=${pageType}`,
        path: `/view/event/add`,
        component: JobEventChartConfigCreateEdit,
    },
    EDIT_EVENT_CHART_CONFIG: {
        to: (pageType, id, page) => `/view/event/edit/${id}?next=${page}&pageType=${pageType}`,
        path: `/view/event/edit/:id`,
        component: JobEventChartConfigCreateEdit,
    },
}

export default routes
